// 提交审批
export function submitApproval (that, memberId, villageId, approvalType, dataId) {
  that.$messagebox({
    message: '确定提交审批？',
    closeOnClickModal: false,
    showCancelButton: true,
    confirmButtonText: '确定'
  }).then(action => {
    if (action === 'confirm') { // 确认的回调
      that.axios.post('/wechat/Approval/submitApproval', {
        member_id: memberId,
        village_id: villageId,
        approval_type: approvalType,
        data_id: dataId
      }).then((res) => {
        if (res.data.status === 1) {
          that.$toast({
            message: '操作成功',
            duration: 5000
          })
          that.$router.go(-1)
        } else {
          that.$toast({
            message: res.data.info,
            duration: 5000
          })
        }
      }).catch(() => {
        that.loading = false
        that.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    }
  })
}
// 重新提交审批
export function resubmitApproval (that, memberId, villageId, approvalId) {
  that.$messagebox({
    message: '确定提交审批？',
    closeOnClickModal: false,
    showCancelButton: true,
    confirmButtonText: '确定'
  }).then(action => {
    if (action === 'confirm') { // 确认的回调
      that.axios.post('/wechat/Approval/resubmitApproval', {
        member_id: memberId,
        village_id: villageId,
        approval_id: approvalId
      }).then((res) => {
        if (res.data.status === 1) {
          that.$toast({
            message: '操作成功',
            duration: 5000
          })
          that.$router.go(-1)
        } else {
          that.$toast({
            message: res.data.info,
            duration: 5000
          })
        }
      }).catch(() => {
        that.loading = false
        that.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/approval.js